const EMPATHY_APP_URL = 'https://x.empathy.co/empathy-x/app.js';

let customerName = '';

function getDeviceType() {
  const userAgent = navigator.userAgent;
  const width = window.innerWidth;

  if (/iPad/i.test(userAgent)) {
    return 'tablet';
  }
  if (/iPhone|iPod/i.test(userAgent)) {
    return 'mobile';
  }
  if (/Android/i.test(userAgent)) {
    if (/Mobile/i.test(userAgent)) {
      return 'mobile';
    } else {
      return 'tablet';
    }
  }

  if (width <= 576) {
    return 'mobile';
  } else if (width <= 992) {
    return 'tablet';
  }

  return 'desktop';
}

const EMPATHY_INSTANCE = 'lolacasademunt';
const EMPATHY_LANG = window.shopifyEmpathyContext?.lang || 'es';
const EMPATHY_STORE = window.shopifyEmpathyContext?.store || 'es';
const EMPATHY_SCOPE = 'desktop';
const EMPATHY_SESSION_KEY = 'empathy-session-id';

function getEmpathySessionId() {
  let sessionId = sessionStorage.getItem(EMPATHY_SESSION_KEY);
  if (!sessionId) {
    sessionId = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(EMPATHY_SESSION_KEY, sessionId);
  }
  return sessionId;
}

function pushEmpathyGtmEvent(event, data = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    instanceID: EMPATHY_INSTANCE,
    lang: EMPATHY_LANG,
    store: EMPATHY_STORE,
    sessionId: getEmpathySessionId(),
    scope: EMPATHY_SCOPE,
    ...data
  });
}

function getResultValue(result, keys) {
  for (const key of keys) {
    if (result?.[key] !== undefined && result[key] !== null && result[key] !== '') return result[key];
  }
  return '';
}

function getResultQuery(result, action) {
  return result?.tagging?.[action]?.params?.q
    || getResultValue(result, ['query', 'q'])
    || new URLSearchParams(window.location.search).get('query')
    || '';
}

function handleEmpathyResultAddToCart(result) {
  const productId = getResultValue(result, ['productId', 'id', 'sku']);
  pushEmpathyGtmEvent('empathy_search_add2cart', {
    q: getResultQuery(result, 'add2cart'),
    title: getResultValue(result, ['title', 'name']) || 'Producto',
    url: getResultValue(result, ['url', 'link']) || window.location.href,
    productId,
    page: 1
  });
}

function handleEmpathyResultWishlist(result) {
  pushEmpathyGtmEvent('empathy_search_wishlist', {
    q: getResultQuery(result, 'click'),
    title: getResultValue(result, ['title', 'name']) || 'Producto',
    url: getResultValue(result, ['url', 'link']) || window.location.href,
    productId: getResultValue(result, ['productId', 'id', 'sku']),
    page: 1
  });
}

const empathyConfig = {
  instance: EMPATHY_INSTANCE,
  scope: 'desktop',
  lang: EMPATHY_LANG,
  uiLang: EMPATHY_LANG,
  currency: 'EUR',
  consent: true,
  documentDirection: 'ltr',
  store: EMPATHY_STORE,
  viewMode: 'fullScreen',
  callbacks: {
    UserClickedResultAddToCart: handleEmpathyResultAddToCart,
    UserClickedResultWishlist: handleEmpathyResultWishlist
  }
};

window.initX = empathyConfig;

function trackEmpathyAddToCart(productId) {
  if (window.InterfaceX && typeof window.InterfaceX.addProductToCart === 'function') {
    window.InterfaceX.addProductToCart(productId);
  }
}

function emitEmpathyCartEvent(name, detail) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: `empathy_cart_${name}`,
    instanceID: EMPATHY_INSTANCE,
    lang: EMPATHY_LANG,
    store: EMPATHY_STORE,
    sessionId: getEmpathySessionId(),
    scope: EMPATHY_SCOPE,
    ...detail
  });
  window.dispatchEvent(new CustomEvent(`empathy:${name}`, { detail }));
}

function getRequestUrl(input) {
  return typeof input === 'string' ? input : input?.url || '';
}

function getProductIdFromCartResponse(data) {
  return data?.items?.[0]?.product_id || data?.items?.[0]?.id || data?.product_id || data?.id;
}

function getRequestBody(input, options) {
  const body = options?.body || (typeof Request !== 'undefined' && input instanceof Request ? input.body : null);
  if (typeof body !== 'string') return null;

  try {
    return JSON.parse(body);
  } catch {
    return null;
  }
}

const nativeFetch = window.fetch.bind(window);
window.fetch = async (...args) => {
  const response = await nativeFetch(...args);
  const url = getRequestUrl(args[0]);
  const responseUrl = new URL(url || response.url, window.location.origin);
  const payload = response.clone();
  const requestBody = getRequestBody(args[0], args[1]);

  if (!response.ok) return response;

  if (responseUrl.pathname.endsWith('/cart/add.js') || responseUrl.pathname.endsWith('/cart/add')) {
    payload.json().then(data => {
      const productId = getProductIdFromCartResponse(data);
      trackEmpathyAddToCart(productId);
      emitEmpathyCartEvent('add', { productId, response: data });
    }).catch(() => {});
  } else if (responseUrl.pathname.endsWith('/cart/change.js') || responseUrl.pathname.endsWith('/cart/change')) {
    payload.json().then(data => {
      const eventName = Number(requestBody?.quantity) === 0 ? 'remove' : 'update';
      emitEmpathyCartEvent(eventName, { request: requestBody, response: data });
    }).catch(() => {});
  } else if (responseUrl.pathname.endsWith('/cart/update.js') || responseUrl.pathname.endsWith('/cart/update')) {
    payload.json().then(data => emitEmpathyCartEvent('update', { response: data })).catch(() => {});
  }

  return response;
};

let empathyAppPromise;

function loadEmpathyApp() {
  if (window.InterfaceX && typeof window.InterfaceX.search === 'function') {
    return Promise.resolve();
  }

  if (empathyAppPromise) return empathyAppPromise;

  empathyAppPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = EMPATHY_APP_URL;
    script.type = 'module';
    script.onload = resolve;
    script.onerror = () => {
      empathyAppPromise = null;
      reject();
    };
    document.head.appendChild(script);
  });

  return empathyAppPromise;
}

function preloadEmpathyApp() {
  loadEmpathyApp().catch(() => {});
}

document.addEventListener('pointerover', event => {
  if (event.target.closest('[data-empathy-search-trigger]')) {
    preloadEmpathyApp();
  }
}, true);

document.addEventListener('focusin', event => {
  if (event.target.closest('[data-empathy-search-trigger]')) {
    preloadEmpathyApp();
  }
}, true);

const scheduleEmpathyPreload = window.requestIdleCallback || function (callback) {
  setTimeout(callback, 2500);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    scheduleEmpathyPreload(preloadEmpathyApp);
  }, { once: true });
} else {
  scheduleEmpathyPreload(preloadEmpathyApp);
}

document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-empathy-search-trigger]');
  if (!trigger) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const searchDrawer = trigger.closest('search-drawer');
  if (searchDrawer?.details?.hasAttribute('open')) {
    searchDrawer.toggleDrawer();
  }

  loadEmpathyApp()
    .then(() => {
      if (typeof window.InterfaceX?.search === 'function') {
        window.InterfaceX.search();
      }
    })
    .catch(() => {});
}, true);
